import { render, staticRenderFns } from "./ApiTokenEdit.vue?vue&type=template&id=6f90acda&"
import script from "./ApiTokenEdit.vue?vue&type=script&lang=js&"
export * from "./ApiTokenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports